import {
	Component,
	OnInit,
	ViewChild,
	ElementRef,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { Modalable } from "@app/Modalable"
import { PrivacyComponent } from "@app/privacy/privacy.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"

@Component({
	selector: "app-open-privacy",
	imports: [COMMON_IMPORTS, PrivacyComponent, LangValPipe],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div
			class="row instructions"
			style="font-size: 1rem; padding: 20px 10px;"
		>
			<div>
				כחלק מהתאמת התוכנה לתיקון 13 לחוק הפרטיות, אנו מבקשים את עיונך במדיניות
				הפרטיות המעודכנת, וכן את אישורך.
			</div>
			<div class="py-3">במידה ועולה בך הסתייגות, יש ליצור עימנו קשר.</div>
			<div>עבודה נעימה,</div>
			<div style="font-weight: 600">צוות My-Cliniq</div>
			<app-privacy
				style="margin-top: 25px;
    box-shadow: 0 0 30px -10px rgba(0, 0, 0, .3);"
			/>
		</div>

		<div class="modal-btns">
			<button
				class="btn btn-default"
				(click)="onClose.emit()"
			>
				{{ "remind_me_later" | langVal }}
			</button>

			<button
				class="btn btn-primary	"
				(click)="update_privacy(true)"
			>
				{{ "i_accept" | langVal }}
			</button>
		</div>
	`,
})
export class OpenPrivacyComponent extends Modalable {
	async update_privacy(is_accept: boolean = false) {
		this.onClose.emit(true)
		await this.apiService.post("update_privacy", {
			is_accept,
		})
		if (is_accept) {
			this.modalService.openToast("updated")
		}
	}
}
